import React, { Component } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';

// import gaPush from '../../../../../../globs/utils/google-analytics';

class FilterPop extends Component {
  constructor(props) {
    const showRebateFilter = props.user.settings_data.SHOW_REBATE_FILTER || false;
    const showCreditNoteFilter = props.user.settings_data.CREDIT_NOTE_FILTER || false;
    const paymentFilterType = props.user.settings_data.PAYMENT_TYPE_FILETER || { 'INV': true, 'CIN': true, 'CO': true };
    super(props);
    this.state = {
      isHeaderVisible: true,
      isFooterVisible: true,
      isInputFocused: false,
      months: moment.months(),
      years: moment().year(),
      selectedYear: props.selectedYear,
      selectedMonth: props.selectedMonth,
      selectedType: props.selectedType,
      showRebateFilter,
      showCreditNoteFilter,
      noOfYearsToShow: 3,
      isAppliedFilter: false,
      paymentFilterType,
    };
    this.compareRef = React.createRef();
  }

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;
  }

  applyFilter = () => {
    const { props, state } = this;
    // this.fireGaEvent('Payments and invoices', 'Statement', `Month: ${state.selectedMonth} Year: ${state.selectedYear} and type: ${state.selectedType}`);
    // props.applyFilter(state.selectedMonth, state.selectedYear, state.selectedType);
    this.setState({ isAppliedFilter: true }, () => {
      // this.fireGaEvent('Payments and invoices', 'Statement', `Month: ${state.selectedMonth} Year: ${state.selectedYear} and type: ${state.selectedType}`);
      props.applyFilter(state.selectedMonth, state.selectedYear,
        state.selectedType, this.state.isAppliedFilter);
    });
  }

  resetFilter = () => {
    // const { props } = this;
    let month = moment().month() + 1;
    month = String(month).length === 1 ? `0${month}` : month;
    const selectedYear = moment().year();
    // const selectedType = ['ALL'];
    this.setState({
      selectedMonth: month,
      selectedYear,
      selectedType: [],
      isAppliedFilter: false,
    }, 
    // () => {
    //   props.applyFilter(month, selectedYear, selectedType);
    // }
    );
  }
  handleMonthChange = (e) => {
    const month = e.target.value.length === 1 ? `0${e.target.value}` : e.target.value;
    this.setState({
      selectedMonth: month,
    });
  }
  handleYearChange = (e) => {
    this.setState({
      selectedMonth: '01',
      selectedYear: Number(e.target.value),
    });
  }
  fireGaEvent = (act, action, label) => {
    // gaPush('event', {
    //   category: act,
    //   action,
    //   label,
    // });
  };
  handleTypeChange = (e) => {
    const { state } = this;
    const type = e.target.value;
    let finalTypeArr = [];
    const arr = [...state.selectedType];
    const index = arr.indexOf(type);
    // console.log('type', type);
    if (!state.selectedType.includes(type)) {
      if (type !== 'ALL') {
        const indexofAll = arr.indexOf('ALL');
        if (indexofAll > -1) {
          arr.splice(indexofAll, 1);
        }
        finalTypeArr = [...arr, e.target.value];
      } else {
        finalTypeArr = ['ALL'];
      }
      const refNode = this.compareRef.current;
      console.log('aa ccc', Object.keys(refNode.childNodes).length - 1);
      if (finalTypeArr.length === Object.keys(refNode.childNodes).length - 1) {
        finalTypeArr = ['ALL'];
      }
    } else if (type === 'ALL') {
      finalTypeArr = ['ALL'];
    } else {
      if (index > -1) {
        arr.splice(index, 1);
      }
      finalTypeArr = arr;
    }
    // console.log('finalTypeArr before', finalTypeArr);
    this.setState({
      selectedType: finalTypeArr,
    });
  }

  renderFiltersYear = () => {
    const optionVariable = [];
    let i = 0;
    while (i < this.state.noOfYearsToShow) {
      optionVariable.push(<option value={this.state.years - i} key={this.state.years - i}>{moment(String(this.state.years - i)).format('YYYY')}</option>);
      i += 1;
    }
    return optionVariable;
  };

  render() {
    const { props, state } = this;
    console.log('del', props)
    const classes = {
      view: classNames('lr-make-sale lr-overlay', {
      }),
    };

    // const makeSaleHeader = 'Filter Orders';
    return (
      <div className="filter-pop">
        <div className={classes.view}>
          {
            state.isHeaderVisible &&
            <div className="lr-overlay__header">
              <div className="lr-overlay__header-title">
                <button
                  type="button"
                  className="lr-overlay__header-back-button"
                  onClick={props.onBackButtonEvent}
                >
                  <i className="icon-back" />
                </button>
                <div>Filter</div>
              </div>
            </div>
          }
          <div className="lr-overlay__body order-detail">
            <div className="filter-content">
              {/* <h6><FormattedMessage id="Digitalordering.SelectDates" /></h6> */}
              <div className="lr-date-row">
                <p><span>Year</span></p>
                <select value={this.state.selectedYear} onChange={this.handleYearChange}>
                  {this.renderFiltersYear()}
                  {/* <option value={state.years}>{moment(String(stateYears)).
                  format('YYYY')}</option>
                  <option value={state.years - 1}>{moment(String(previousStateYears)).
                    format('YYYY')}</option>
                  <option value={state.years - 2}>{moment(String(lastPreviousStateYears)).
                  format('YYYY')}</option> */}
                </select>
              </div>
              <div className="lr-date-row">
                <p><span>Month</span></p>
                <select value={Number(this.state.selectedMonth)} onChange={this.handleMonthChange}>
                  {
                    state.months.map((month, index) => {
                      if (state.selectedYear === moment().year() &&
                        (index <= Number(moment().month()))) {
                        return (
                          <option selected="selected" value={index + 1} key={month}>{month}</option>
                        );
                      } else if (state.selectedYear < (moment().year())) {
                        return (
                          <option value={index + 1} key={month}>{month}</option>
                        );
                      }
                      return false;
                    })
                  }
                </select>
              </div>
              <div className="lr-add-an-order__product-list__item lr-filter-row" ref={this.compareRef}>
                <div>
                  <label htmlFor="ALL">
                    <span>All</span>
                    <input
                      name="ALL"
                      type="checkbox"
                      value="ALL"
                      checked={state.selectedType.includes('ALL')}
                      onChange={this.handleTypeChange}
                    />
                  </label>
                </div>
                {
                  state.paymentFilterType["RCT"] &&
                  <div>
                    <label htmlFor="RCT">
                      Receipt
                      <input
                        name="RCT"
                        type="checkbox"
                        value="RCT"
                        checked={state.selectedType.includes('RCT')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["CIN"] &&
                  <div>
                    <label htmlFor="CIN">
                      Cleared Invoice
                      <input
                        name="CIN"
                        type="checkbox"
                        value="CIN"
                        checked={state.selectedType.includes('CIN')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["INV"] &&
                  <div>
                    <label htmlFor="INV">
                      Open Invoice
                      <input
                        name="INV"
                        type="checkbox"
                        value="INV"
                        checked={state.selectedType.includes('INV')}
                        onChange={this.handleTypeChange}INV
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["OB"] &&
                  <div>
                    <label htmlFor="OB">
                      Opening Balance
                      <input
                        name="OB"
                        type="checkbox"
                        value="OB"
                        checked={state.selectedType.includes('OB')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["DN"] &&
                  <div>
                    <label htmlFor="DN">
                      Debit Note
                      <input
                        name="DN"
                        type="checkbox"
                        value="DN"
                        checked={state.selectedType.includes('DN')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                
                {
                  state.paymentFilterType["CN"] &&
                  <div>
                    <label htmlFor="CN">
                      Credit Note
                      <input
                        name="CN"
                        type="checkbox"
                        value="CN"
                        checked={state.selectedType.includes('CN')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["CB"] &&
                  <div>
                    <label htmlFor="CB">
                      Closing Balance
                      <input
                        name="CB"
                        type="checkbox"
                        value="CB"
                        checked={state.selectedType.includes('CB')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["CNT"] &&
                  <div>
                    <label htmlFor="CNT">
                      Credit Note
                      <input
                        name="CNT"
                        type="checkbox"
                        value="CNT"
                        checked={state.selectedType.includes('CNT')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["REB"] &&
                  <div>
                    <label htmlFor="REB">
                      Rebate
                      <input
                        name="REB"
                        type="checkbox"
                        value="REB"
                        checked={state.selectedType.includes('REB')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["PAY"] &&
                  <div>
                    <label htmlFor="PAY">
                      Payment
                      <input
                        name="PAY"
                        type="checkbox"
                        value="PAY"
                        checked={state.selectedType.includes('PAY')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
                {
                  state.paymentFilterType["UL"] &&
                  <div>
                    <label htmlFor="UL">
                    Un Invoiced Loads
                      <input
                        name="UL"
                        type="checkbox"
                        value="UL"
                        checked={state.selectedType.includes('UL')}
                        onChange={this.handleTypeChange}
                      />
                    </label>
                  </div>
                }
              </div>
              <div className="flexbox btn-container">
                <a className="lr-button lr-button--primary  lr-orders__add-new-order-button" onClick={this.resetFilter}><div>Reset</div></a>
                <a className="lr-button lr-button--primary  lr-orders__add-new-order-button" onClick={this.applyFilter}><div>Apply</div></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterPop.propTypes = {
  selectedMonth: PropTypes.number.isRequired,
  selectedYear: PropTypes.number.isRequired,
  selectedType: PropTypes.arrayOf(PropTypes.string).isRequired,
  onBackButtonEvent: PropTypes.func.isRequired,
  user: PropTypes.shape({
    settings_data: PropTypes.shape({
      SHOW_REBATE_FILTER: PropTypes.bool,
      CREDIT_NOTE_FILTER: PropTypes.bool,
    }),
  }),
};

FilterPop.defaultProps = {
  user: undefined,
};

export default FilterPop;
